import { Card } from '@mui/material';
import { ExtractionCardHeader } from './ExtractionCardHeader';

import classes from './ExtractionCardShell.module.css';

export function ExtractionCardShell({
  children,
  headerActions,
}: {
  children: React.ReactNode;
  headerActions?: React.ReactNode;
}) {
  return (
    <Card className={classes.extractionShellCard}>
      <ExtractionCardHeader actions={headerActions} />
      {children}
    </Card>
  );
}
